import { toHex } from '../helpers/toHex';
import { MessageFragment } from '../../types/messageFragment';
import { GroupedMessageResult } from '../../types/groupedMessageResult';
import { groupMessageFragmentsInPlace } from '../helpers/groupMessageFragmentsInPlace';

/**
 * Adds new fragments into an existing fragment store, grouped by messageId.
 *
 * @param fragmentStore - The current in-memory fragment store
 * @param newFragments - Incoming fragments to add
 * @returns Updated grouped messages after merge
 */
export function storeAndGroupFragments(
  fragmentStore: Map<string, MessageFragment[]>,
  newFragments: MessageFragment[]
): GroupedMessageResult[] {
  for (const frag of newFragments) {
    const id = toHex(frag.messageId);
    if (!fragmentStore.has(id)) fragmentStore.set(id, []);
    fragmentStore.get(id)!.push(frag);
  }

  return groupMessageFragmentsInPlace(fragmentStore);
}